export default __webpack_public_path__ + "static/media/SWT1370.34I-34996_-24483_0.09a02f8e.jpg";